import React, { useEffect, useState } from 'react'

const Work = () => {

    useEffect(() => {
        document.title = 'AmanChauhan-Experience'
    })

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loader = document.getElementById("preloader");

        const handleLoad = () => {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            if (loader) {
                loader.style.display = "none";
            }
        };

        const isMobile = window.innerWidth <= 840;

        if (isMobile) {
            handleLoad();  // Directly call handleLoad for mobile devices
        } else if (document.readyState === 'complete') {
            // If the document is already loaded, call handleLoad immediately
            handleLoad();
        } else {
            window.addEventListener("load", handleLoad);
        }

        return () => {
            window.removeEventListener("load", handleLoad);
        };
    }, []); // Empty dependency array means this effect runs once on component mount

    return (
        <>
            {loading ? (
                <div id="preloader" className='preloader'>
                    <img src="../IMG/Aman.png" className='preload-img' alt="AMAN CHAUHAN" />
                    <h2 className='preload-heading'>AMAN CHAUHAN</h2>
                </div>
            ) :
                <section id="Work" className="Work">

                    <div style={{ padding: 0 }}>

                        <div className="timeline-section">
                            <h1 className="mb-5 mt-2 Edu-heading" data-aos={`${window.innerWidth >= 820 ? 'fade-right' : 'fade-up'}`} data-aos-duration="1000">EXPERIENCE</h1>
                            <div className="timeline-items">
                                <div className="timeline-item" data-aos="fade-up" data-aos-duration="1000">
                                    <div className="timeline-dot"></div>
                                    <div className="timeline-content">
                                        <p className="Edu-year">Sep 2024 - Dec 2024</p>
                                        <p className="fs-6 text-white">(4 MONTHS)</p>
                                        <p className="Edu-clg">Vogueish</p>
                                        <p className="Edu-Ach">Lead Backend Developer</p>
                                        <ul className="Edu-Para-left">
                                            <li>Led a 6-person backend team to develop a robust e-commerce platform using Node.js and MongoDB.</li>
                                            <li>Designed REST APIs for user authentication, product, cart, and order operations.</li>
                                            <li>Integrated Stripe for secure payments and collaborated with frontend teams for optimized UX.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="timeline-item" data-aos="fade-up" data-aos-duration="1000">
                                    <div className="timeline-dot"></div>
                                    <div className="timeline-content">
                                        <p className="Edu-year">May 2025 - Jun 2025</p>
                                        <p className="fs-6 text-white">(2 MONTHS)</p>
                                        <p className="Edu-clg">Impause (Freelance)</p>
                                        <p className="Edu-Ach">App Developer</p>
                                        <ul className="Edu-Para-right">
                                            <li>Built a cross-platform mobile app for financial behavior change using React Native and Expo.</li>
                                            <li>Integrated Supabase for real-time operations and authentication; used Plaid API for secure banking access.</li>
                                            <li>Managed subscriptions with RevenueCat and ensured seamless Figma-based UI implementation.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="timeline-item" data-aos="fade-up" data-aos-duration="1000">
                                    <div className="timeline-dot"></div>
                                    <div className="timeline-content">
                                        <p className="Edu-year">Jun 2025 - Present</p>
                                        {/* <p className="fs-6 text-white">(ONGOING)</p> */}
                                        <p className="Edu-clg">Delhi Technological University (DTU)</p>
                                        <p className="Edu-Ach">Research Intern - Computer Vision</p>
                                        <ul className="Edu-Para-right">
                                            <li>Contributing to a deep learning-based 6D object pose estimation project.</li>
                                            <li>Focused on dataset preparation, model training, and evaluation for vision systems.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="timeline-item">
                                    <div className="timeline-dot"></div>
                                </div>
                            </div>
                        </div>


                        <div className="timeline-section">
                            <h1 className="mb-5 mt-2 Edu-heading" data-aos={`${window.innerWidth >= 820 ? 'fade-right' : 'fade-up'}`} data-aos-duration="1000">EDUCATION</h1>
                            <div className="timeline-items">
                                <div className="timeline-item" data-aos="fade-up" data-aos-duration="1000">
                                    <div className="timeline-dot"></div>
                                    <div className="timeline-content">
                                        <p className="Edu-year">2010-2020</p>
                                        <p className="Edu-clg">Kendriya Vidyalaya Andrews Ganj (KVAG)</p>
                                        <p className="Edu-Ach">Secondary Education</p>
                                        <ul className="Edu-Para-right">
                                            <li>Scored 92.4% in CBSE Class X and awarded merit certificate in Mathematics.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="timeline-item" data-aos="fade-up" data-aos-duration="1000">
                                    <div className="timeline-dot"></div>
                                    <div className="timeline-content">
                                        <p className="Edu-year">2020-2022</p>
                                        <p className="Edu-clg">Kendriya Vidyalaya Andrews Ganj (KVAG)</p>
                                        <p className="Edu-Ach">Senior Secondary Education</p>
                                        <ul className="Edu-Para-left">
                                            <li>Scored 96.2% in CBSE Class XII; awarded Mathematics merit certificate.</li>
                                            <li>Ranked in the top 1.5% of students nationwide in the Senior Secondary Certification Examination (2022), conducted by the Central Board of Secondary Education (CBSE).</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="timeline-item" data-aos="fade-up" data-aos-duration="1000">
                                    <div className="timeline-dot"></div>
                                    <div className="timeline-content">
                                        <p className="Edu-year">2022 - Present</p>
                                        <p className="Edu-clg">Delhi Technological University (DTU)</p>
                                        <p className="Edu-Ach">B.Tech in Computer Engineering</p>
                                        <ul className="Edu-Para-right">
                                            <li>Currently pursuing undergraduate studies with a CGPA of 8.19.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="timeline-item">
                                    <div className="timeline-dot"></div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div id="Skills">
                        <h3 data-aos={`${window.innerWidth >= 820 ? 'fade-left' : 'fade-up'}`} data-aos-duration="1000">Core Skills</h3>
                        <div className="Main-Skills">
                            <div className="Skills-container" data-aos="fade-up" data-aos-duration="1000">

                                <div className="skill-box">
                                    <span className="title">Python</span>
                                    <div className="skill-bar">
                                        <span className="skill-per python">
                                            <span className="tooltip--per">90%</span>
                                        </span>
                                    </div>
                                </div>

                                {/* <div className="skill-box">
                                    <span className="title">PyTorch</span>
                                    <div className="skill-bar">
                                        <span className="skill-per pytorch">
                                            <span className="tooltip--per">85%</span>
                                        </span>
                                    </div>
                                </div>

                                <div className="skill-box">
                                    <span className="title">TensorFlow</span>
                                    <div className="skill-bar">
                                        <span className="skill-per tensorflow">
                                            <span className="tooltip--per">80%</span>
                                        </span>
                                    </div>
                                </div>

                                <div className="skill-box">
                                    <span className="title">OpenCV</span>
                                    <div className="skill-bar">
                                        <span className="skill-per opencv">
                                            <span className="tooltip--per">85%</span>
                                        </span>
                                    </div>
                                </div> */}

                                <div className="skill-box">
                                    <span className="title">React.js</span>
                                    <div className="skill-bar">
                                        <span className="skill-per reactjs">
                                            <span className="tooltip--per">95%</span>
                                        </span>
                                    </div>
                                </div>

                                <div className="skill-box">
                                    <span className="title">Next.js</span>
                                    <div className="skill-bar">
                                        <span className="skill-per nextjs">
                                            <span className="tooltip--per">92%</span>
                                        </span>
                                    </div>
                                </div>

                                <div className="skill-box">
                                    <span className="title">React Native</span>
                                    <div className="skill-bar">
                                        <span className="skill-per reactnative">
                                            <span className="tooltip--per">90%</span>
                                        </span>
                                    </div>
                                </div>

                                <div className="skill-box">
                                    <span className="title">Node.js</span>
                                    <div className="skill-bar">
                                        <span className="skill-per nodejs">
                                            <span className="tooltip--per">94%</span>
                                        </span>
                                    </div>
                                </div>

                                <div className="skill-box">
                                    <span className="title">REST APIs</span>
                                    <div className="skill-bar">
                                        <span className="skill-per restapi">
                                            <span className="tooltip--per">85%</span>
                                        </span>
                                    </div>
                                </div>

                                <div className="skill-box">
                                    <span className="title">Data Structures & Algorithms</span>
                                    <div className="skill-bar">
                                        <span className="skill-per data-structures">
                                            <span className="tooltip--per">89%</span>
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="Working-Areas">
                            <h3 data-aos="fade-up" data-aos-duration="1000">Domain Expertise</h3>
                            <div className="Skills-container" data-aos="fade-up" data-aos-duration="1000">

                                <div className="skill-box">
                                    <span className="title">Computer Vision</span>
                                    <div className="skill-bar">
                                        <span className="skill-per computer-vision">
                                            <span className="tooltip--per">75%</span>
                                        </span>
                                    </div>
                                </div>

                                <div className="skill-box">
                                    <span className="title">Deep Learning</span>
                                    <div className="skill-bar">
                                        <span className="skill-per deep-learning">
                                            <span className="tooltip--per">68%</span>
                                        </span>
                                    </div>
                                </div>

                                <div className="skill-box">
                                    <span className="title">Web Development</span>
                                    <div className="skill-bar">
                                        <span className="skill-per web-development">
                                            <span className="tooltip--per">89%</span>
                                        </span>
                                    </div>
                                </div>

                                <div className="skill-box">
                                    <span className="title">Mobile App Development</span>
                                    <div className="skill-bar">
                                        <span className="skill-per mobile-app">
                                            <span className="tooltip--per">88%</span>
                                        </span>
                                    </div>
                                </div>

                                <div className="skill-box">
                                    <span className="title">API & Backend Engineering</span>
                                    <div className="skill-bar">
                                        <span className="skill-per backend-api">
                                            <span className="tooltip--per">97%</span>
                                        </span>
                                    </div>
                                </div>

                                <div className="skill-box">
                                    <span className="title">Full-Stack Development</span>
                                    <div className="skill-bar">
                                        <span className="skill-per fullstack">
                                            <span className="tooltip--per">83%</span>
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="Other-Skills mt-2">
                            <h5 className="My-knowledge" data-aos="fade-up" data-aos-duration="500">Tools & Technologies</h5>

                            <div id="OSkills">

                                <div className="OSkills-Group">
                                    <h6 className="OSkills-Title">Programming Languages</h6>
                                    <div className='OSkills-container'>
                                        <div className="OSkills">Python</div>
                                        <div className="OSkills">C/C++</div>
                                        <div className="OSkills">JavaScript</div>
                                    </div>
                                </div>

                                <div className="OSkills-Group">
                                    <h6 className="OSkills-Title">Deep Learning & Computer Vision</h6>
                                    <div className='OSkills-container'>
                                        <div className="OSkills">PyTorch</div>
                                        <div className="OSkills">TensorFlow</div>
                                        <div className="OSkills">Keras</div>
                                        <div className="OSkills">OpenCV</div>
                                    </div>
                                </div>

                                <div className="OSkills-Group">
                                    <h6 className="OSkills-Title">ML & Data Tools</h6>
                                    <div className='OSkills-container'>
                                        <div className="OSkills">Scikit-Learn</div>
                                        <div className="OSkills">NumPy</div>
                                        <div className="OSkills">Pandas</div>
                                        <div className="OSkills">NLTK</div>
                                    </div>
                                </div>

                                <div className="OSkills-Group">
                                    <h6 className="OSkills-Title">Frontend & Styling</h6>
                                    <div className='OSkills-container'>
                                        <div className="OSkills">React.js</div>
                                        <div className="OSkills">Next.js</div>
                                        <div className="OSkills">Tailwind CSS</div>
                                        <div className="OSkills">Bootstrap</div>
                                        <div className="OSkills">HTML & CSS</div>
                                    </div>
                                </div>

                                <div className="OSkills-Group">
                                    <h6 className="OSkills-Title">Backend & APIs</h6>
                                    <div className='OSkills-container'>
                                        <div className="OSkills">Node.js</div>
                                        <div className="OSkills">Express.js</div>
                                        <div className="OSkills">REST APIs</div>
                                    </div>
                                </div>

                                <div className="OSkills-Group">
                                    <h6 className="OSkills-Title">Mobile Development</h6>
                                    <div className='OSkills-container'>
                                        <div className="OSkills">React Native</div>
                                        <div className="OSkills">Expo</div>
                                    </div>
                                </div>

                                <div className="OSkills-Group">
                                    <h6 className="OSkills-Title">Databases & Auth</h6>
                                    <div className='OSkills-container'>
                                        <div className="OSkills">MongoDB</div>
                                        <div className="OSkills">PostgreSQL</div>
                                        <div className="OSkills">MySQL</div>
                                        <div className="OSkills">Firebase</div>
                                        <div className="OSkills">Supabase</div>
                                    </div>
                                </div>

                                <div className="OSkills-Group">
                                    <h6 className="OSkills-Title">Developer Tools</h6>
                                    <div className='OSkills-container'>
                                        <div className="OSkills">Git</div>
                                        <div className="OSkills">Linux (Kali)</div>
                                        <div className="OSkills">Jupyter</div>
                                        <div className="OSkills">Vite</div>
                                    </div>
                                </div>

                                <div className="OSkills-Group">
                                    <h6 className="OSkills-Title">API & Integration</h6>
                                    <div className='OSkills-container'>
                                        <div className="OSkills">Stripe API</div>
                                        <div className="OSkills">Paytm API</div>
                                        <div className="OSkills">Plaid API</div>
                                        <div className="OSkills">RevenueCat</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section >
            }

        </>
    )
}

export default Work